import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vueDebounce from "vue-debounce";
import moment from "moment";
import "./assets/Icons/icons.scss";
import WsPlugin from "adonis-vue-websocket";
import Ws from "@adonisjs/websocket-client";
import VueSocialSharing from "vue-social-sharing";
import VueMeta from "vue-meta";
// import VueWeChatShare from 'vue-wechat-share'

// Vue.use(VueWeChatShare)

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

Vue.use(WsPlugin, { adonisWS: Ws });

Vue.use(VueSocialSharing);

Vue.config.productionTip = false;

moment.locale(navigator.language === "pt-BR" ? "pt-br" : "en-us");

Vue.use(vueDebounce);

Vue.filter("formatDateGlobal", function(value) {
  if (!value) return "";
  return moment(value).format("DD MMMM YYYY HH:mm");
});

// Vue.filter("formatNumberGlobal", function(value) {
//   if (value === 0) return `R$ 0,00`;
//   else if (!value && !isNaN(value)) return "";
//   return value.toLocaleString("pt-br", { style: "currency", currency: "BRL" });
// });

Vue.filter("formatFloatGlobal", function(value) {
  if (value === 0) return `0`;
  else if (!value && !isNaN(value)) return "";
  return value.toLocaleString(navigator.language, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
